var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.2 18.143a2.694 2.694 0 0 0-.187-.947 7.026 7.026 0 0 0-.921-1.6c-.175-.243-.366-.5-.662-.877-.08-.1-.176-.228-.358-.46-.148-.189-.259-.333-.369-.476C.733 11.213 0 9.453 0 7.286A7.156 7.156 0 0 1 7 0a7.156 7.156 0 0 1 7 7.286c0 2.166-.733 3.928-2.7 6.5-.1.132-.208.271-.368.476l-.359.46c-.3.383-.49.637-.661.877a6.98 6.98 0 0 0-.921 1.6 2.679 2.679 0 0 0-.187.947 1.8 1.8 0 1 1-3.6 0zM1 7.286c0 1.914.677 3.514 2.5 5.891l.043.057.32.411.2.263.156.2c.315.406.507.66.684.906a7.929 7.929 0 0 1 1.045 1.832 3.644 3.644 0 0 1 .251 1.3.8.8 0 1 0 1.6 0 3.644 3.644 0 0 1 .251-1.3 7.929 7.929 0 0 1 1.05-1.833c.186-.259.384-.522.684-.906l.154-.2.206-.264c.146-.186.256-.329.363-.468C12.322 10.8 13 9.205 13 7.286A6.154 6.154 0 0 0 7 1a6.155 6.155 0 0 0-6 6.286zM4.5 7A2.5 2.5 0 1 1 7 9.5 2.5 2.5 0 0 1 4.5 7zm1 0A1.5 1.5 0 1 0 7 5.5 1.5 1.5 0 0 0 5.5 7z",
    transform: "translate(5 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLocation);
export default __webpack_public_path__ + "static/media/IconsLocation.186a30793a2656fc8fc10995900794df.svg";
export { ForwardRef as ReactComponent };